export enum FilterSettingsError {
  SchemaCompute = 'SchemaCompute',
  EmptySchema = 'EmptySchema',
  IncompleteSettings = 'IncompleteSettings',
}
